// extracted by mini-css-extract-plugin
export var cardLayout = "_60-1";
export var paginationContainer = "_60-0";